var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group_1424",
    "data-name": "group 1424",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\u76F4\\u7EBF_429",
    "data-name": "\\u76F4\\u7EBF 429",
    x2: 23,
    fill: "none",
    stroke: "#4b4b4b",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u76F4\\u7EBF_430",
    "data-name": "\\u76F4\\u7EBF 430",
    x2: 23,
    transform: "translate(0 8)",
    fill: "none",
    stroke: "#4b4b4b",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u76F4\\u7EBF_431",
    "data-name": "\\u76F4\\u7EBF 431",
    x2: 23,
    transform: "translate(0 16)",
    fill: "none",
    stroke: "#4b4b4b",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/BurgerMenu.1b52e67244a82b3d736848454f37de45.svg";
export { ForwardRef as ReactComponent };